import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-quarter-filter',
  templateUrl: './quarter-filter.component.html',
  styleUrls: ['./quarter-filter.component.scss']
})
export class QuarterFilterComponent extends FilterAbstractModel implements OnInit, OnDestroy, OnChanges {

    listQuarterFilter: any[];

    @Input() quarterData: any;
    @Input() quarterSelected: number;

    constructor() {
      super();
    }

    ngOnInit() {
    }

    ngOnChanges (changes: SimpleChanges) {
      if ('quarterData' in changes) {
        this.listQuarterFilter = this.quarterData;
        this.optionSelected = this.listQuarterFilter ? this.listQuarterFilter[0] : null;
      }
      if (this.quarterSelected) {
        this.optionSelected = this.quarterSelected;
      }
    }

    reset() {
      this.optionSelected = this.listQuarterFilter ? this.listQuarterFilter[0] : null;
    }


    ngOnDestroy(): void {
    }

  }

